let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c4vbc")).then(() => parcelRequire('1utEm'));